import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const PlacesPage = lazy(() => import('src/pages/places/list'));
const PlaceDetailsPage = lazy(() => import('src/pages/places/details'));
const PlaceNewPage = lazy(() => import('src/pages/places/create'));

const StoriesPage = lazy(() => import('src/pages/stories/list'));
const StoryDetailsPage = lazy(() => import('src/pages/stories/details'));

const GuidesPage = lazy(() => import('src/pages/guides/list'));
const GuideDetailsPage = lazy(() => import('src/pages/guides/details'));
const GuideNewPage = lazy(() => import('src/pages/guides/create'));

const EventsPage = lazy(() => import('src/pages/events/list'));

const SettingsPage = lazy(() => import('src/pages/settings'));

const AnalyticsPage = lazy(() => import('src/pages/analytics'));

const AtlasAnalyticsPage = lazy(() => import('src/pages/atlasAnalytics/atlasAnalytics'));
const EventDiscoveryPage = lazy(() => import('src/pages/eventDiscovery/eventDiscovery'));
const PlaceBatchesPage = lazy(() => import('src/pages/placeBatches/placeBatches'));
// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: CONFIG.auth.skip ? <>{layoutContent}</> : <AuthGuard>{layoutContent}</AuthGuard>,
    children: [
      { element: <Navigate to="places" replace />, index: true },
      {
        path: 'places',
        children: [
          { element: <PlacesPage />, index: true },
          { path: 'list', element: <PlacesPage /> },
          { path: ':publicID', element: <PlaceDetailsPage /> },
          { path: 'new', element: <PlaceNewPage /> },
        ],
      },
      {
        path: 'stories',
        children: [
          { element: <StoriesPage />, index: true },
          { path: 'list', element: <StoriesPage /> },
          { path: ':publicID', element: <StoryDetailsPage /> },
        ],
      },
      {
        path: 'guides',
        children: [
          { element: <GuidesPage />, index: true },
          { path: ':publicID', element: <GuideDetailsPage /> },
          { path: 'new', element: <GuideNewPage /> },
        ],
      },
      // TODO: uncomment to allow user to reach events from /events
      {
        path: 'events',
        children: [
          { element: <EventsPage />, index: true },
          { path: 'discovery', element: <EventDiscoveryPage /> },
        ],
      },
      {
        path: 'settings',
        children: [{ element: <SettingsPage />, index: true }],
      },
      {
        path: 'analytics',
        children: [{ element: <AnalyticsPage />, index: true }],
      },
      {
        path: 'atlas-analytics',
        children: [{ element: <AtlasAnalyticsPage />, index: true }],
      },
      {
        path: 'place-batches',
        children: [{ element: <PlaceBatchesPage />, index: true }],
      },
    ],
  },
];
